import type { ComponentProps } from 'react'

import { Card } from '@morpho-org/ui-v6/server'
import { cn } from '@morpho-org/ui-v6/utils'
import { Icon } from '@repo/ui'
import { Alert, Info } from '@repo/ui/icons'

interface InfoCalloutProps extends ComponentProps<typeof Card> {
  variant?: 'info' | 'warning'
}

/**
 * The icon-plus-sentence callout used across the withdraw and in-kind redemption
 * surfaces. `@repo/ui`'s `Alert` is the same idea but a different size (12px
 * padding, `text-sm`), so it can't stand in for these without redrawing them.
 */
const InfoCallout = ({ variant = 'info', className, children, ...props }: InfoCalloutProps) => {
  const isWarning = variant === 'warning'
  const foreground = isWarning ? 'text-warning-foreground' : 'text-info-foreground'

  return (
    <Card
      className={cn(
        'gap-2xs flex-row items-start shadow-none',
        isWarning ? 'bg-warning' : 'bg-info',
        className
      )}
      padding="s"
      {...props}
    >
      <Icon className={foreground} icon={isWarning ? <Alert /> : <Info />} />
      <span className={cn('text-2xs', foreground)}>{children}</span>
    </Card>
  )
}

export default InfoCallout
